<template>
  <div class="calendar-toolbar">
    <div class="toolbar-left">
      <b-button
        variant="link"
        class="icon-btn"
        @click="$emit('previousMonth')"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          size="20"
        />
      </b-button>
      <b-button
        variant="link"
        class="icon-btn"
        @click="$emit('nextMonth')"
      >
        <feather-icon
          icon="ChevronRightIcon"
          size="20"
        />
      </b-button>
      <h2 class="toolbar-title">
        {{ currentMonthYear }}
      </h2>
    </div>

    <div class="toolbar-right">
      <b-button
        variant="outline-secondary"
        size="sm"
        class="today-btn"
        @click="$emit('goToToday')"
      >
        Hoje
      </b-button>
      <div class="view-switcher">
        <button
          v-for="option in viewOptions"
          :key="option.value"
          class="view-btn"
          :class="{ active: value === option.value }"
          @click="$emit('input', option.value)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { viewOptions } from '../calendar-utils'

export default {
  name: 'CalendarHeader',
  props: {
    currentMonthYear: { type: String, required: true },
    value: { type: String, required: true },
  },
  data() {
    return { viewOptions }
  },
}
</script>

<style scoped>
.calendar-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #dadce0;
  background: #fff;
  gap: 12px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 4px;
}

.toolbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.toolbar-title {
  margin: 0 0 0 8px;
  font-size: 20px;
  font-weight: 400;
  color: #3c4043;
  letter-spacing: -0.01em;
}

.icon-btn {
  color: #5f6368;
  border: none;
  background: transparent;
  padding: 8px;
  border-radius: 50%;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-btn:hover {
  background: #f1f3f4;
  color: #202124;
}

.today-btn {
  border-color: #dadce0;
  border-radius: 9999px;
  background: #fff;
  color: #3c4043;
  font-weight: 500;
  font-size: 13px;
  padding: 6px 16px;
}

.today-btn:hover {
  background: #f8fafd;
}

.view-switcher {
  display: flex;
  overflow: hidden;
  border-radius: 9999px;
  border: 1px solid #dadce0;
  background: #fff;
}

.view-btn {
  padding: 6px 12px;
  font-size: 13px;
  border: none;
  background: #fff;
  color: #3c4043;
  cursor: pointer;
  transition: all 0.15s;
}

.view-btn:hover {
  background: #f1f3f4;
}

.view-btn.active {
  background: #e8f0fe;
  color: #1967d2;
}
</style>
